import * as Sentry from '@sentry/react';

/**
 * Session Replay is added after the app has rendered instead of being part of the
 * startup bundle (issue #236, F14). Error reporting and tracing start immediately as
 * before; the replay sampling rates set in Sentry.init are unchanged.
 */
export const startReplay = () =>
    import('@sentry/react')
        .then(({ replayIntegration }) => {
            Sentry.addIntegration(replayIntegration({ maskAllText: true, blockAllMedia: true }));
        })
        .catch((error) => console.warn('[Sentry] Replay could not be loaded', error));

/** Runs `task` when the browser is idle (or after `timeout` ms at the latest). */
export const whenIdle = (task: () => void, timeout = 3000) => {
    const ric = (window as any).requestIdleCallback as undefined | ((cb: () => void, opts?: { timeout: number }) => number);
    if (ric) ric(task, { timeout });
    else window.setTimeout(task, 1);
};
